import { User } from 'api/models';
import { useGetManagerOfOptionsQuery } from 'queries/customer-company';
import { useUsersMapQuery } from 'queries/members';

export const useManagerOfUsers = (userId: number) => {
  const { data: reporteeOptions, isLoading: reporteeLoading } =
    useGetManagerOfOptionsQuery(userId, { cacheTime: 0 });

  const { data: allUsersMap, isLoading: mapLoading } = useUsersMapQuery();

  const users: User[] = [];

  if (
    !mapLoading &&
    !reporteeLoading &&
    allUsersMap !== undefined &&
    reporteeOptions !== undefined
  ) {
    reporteeOptions.forEach((uId) => {
      users.push(allUsersMap.get(uId.userId)!);
    });
  }

  return { data: users, isLoading: mapLoading || reporteeLoading };
};
